import { FloatingPortal } from '@floating-ui/react-dom-interactions';
import { PortalNode } from './styled.js';
import { jsx } from 'react/jsx-runtime';

function Portal(props) {
  var children = props.children;
  return /*#__PURE__*/jsx(FloatingPortal, {
    children: /*#__PURE__*/jsx(PortalNode, {
      children: children
    })
  });
}

export { Portal as default };
